export enum LabyrinthDirection {
  UP,
  DOWN,
  LEFT,
  RIGHT,
}
